import BaseAPI from "../api";

const path: string = "/edpex-project-amendment";

export type listType = {
  status?: string;
  created_id?: string;
  created_date?: string;
  modified_id?: string;
  modified_date?: number;
  type?: string;
  keyword?: number;
  limit?: number;
  page?: number;
};

export class edpexProjectAmendmentAPI extends BaseAPI {
  static getEdpexProjecAmendmenttList(query: listType): Promise<any> {
    return this.api.get(`${path}/list`, {
      params: { ...query },
    });
  }

  static createEdpexProjecAmendmentt(body: any): Promise<any> {
    return this.api.post(`${path}`, body);
  }

  static getEdpexProjecAmendmenttById(id: number): Promise<any> {
    return this.api.get(`${path}/${id}`);
  }

  static updateEdpeProject(id: number, body: any): Promise<any> {
    return this.api.patch(`${path}/${id}`, body);
  }

  static deleteEdpexProjecAmendmentt(id: number): Promise<any> {
    return this.api.delete(`${path}/${id}`);
  }

  static updateEdpexAmendmentStatus(id: number, body: any): Promise<any> {
    return this.api.patch(`${path}/${id}/status`, body);
  }
}
